// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2azSu","tab":"Tabs_tab__1E0_7","tabActive":"Tabs_tabActive__1ViGM"};